export enum CommentEditType {
  DELETE = "delete",
  MODERATE = "moderate",
  UPDATE = "update"
}

export enum VoteTypeEdit {
  MODERATE = "moderate",
  UPDATE = "update"
}

export enum RecognitionTypeEdit {
  MODERATE = "moderate",
  UPDATE = "update",
  ARCHIVE = "archive"
}
